import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function TechReading() {
    useEffect(() => {
        document.title = 'КьюАй - Техника чтения';
    }, [])

    return <>
        <div>
            В центре детского развития КьюАй мы предлагаем курс Техника чтения, который поможет ребенку быстро и
            эффективно овладеть навыком чтения. Наши занятия состоят из продуманных упражнений и игр, которые не
            только обучают технике чтения, но и развивают память, внимание и мышление. Ребенок не будет
            чувствовать усталость, а наоборот, будет с удовольствием посещать наши уроки. Мы проводим
            эффективное обучение чтению школьников, ставя в основу технику чтения слова целиком и фразами, что
            помогаем ребенку преодолевать любые трудности в чтении. Подарите вашему ребенку лучший старт в мир
            знаний с КьюАй.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Увеличение скорости чтения минимум в 2-3 раза;</li>
                    <li>Повышение уровня грамотность;</li>
                    <li>Преодоление страха перед чтением;</li>
                    <li>Обучение пониманию прочитанного текста;</li>
                    <li>Развитие способности запоминать большие объемы информации;</li>
                    <li>Повышение концентрации внимания;</li>
                    <li>Развитие у ребенка интереса к чтению;</li>
                    <li>Сокращение времени для выполнения домашнего задания;</li>
                    <li>Формирование мотивации к учебе;</li>
                    <li>Становление уверенность в себе личности.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-tch"></div>
            </div>
        </div>
        <div>
            Школа КьюАй – источник вдохновения и заряда на успех для наших воспитанников. Курс Техника чтения
            превратит процесс чтения из тяжелой работы в увлекательное занятие. Мы с уверенностью можем сказать,
            что школьное обучение для Вашего ребенка станет в разы легче. Ведь большинство воспитанников нашей
            школы начинают учиться лучше. Вы будете поражены, как быстро ваш ребенок сможет выполнять домашнее
            задание. Эффективность нашего курса проверена многолетним опытом.
        </div>
        <div>
            Вы хотите, чтобы ваш ребенок стал успешным в школе? Поддержите его развитие, записав на курс
            "Техника чтения" в центре детского развития КьюАй. Наши опытные преподаватели помогут Вашему ребенку
            улучшить навыки чтения и восприятия информации, что приведет к высоким оценкам в школе. Не упустите
            шанс обеспечить лучшее будущее для вашего ребенка!
        </div>
    </>
}